export const FORM_STATE = {
  success: 'success',
  error: 'error',
}
